/** 빈 값이면 같은 origin 기준 상대 경로(/api/...) 사용. 로컬 개발은 package.json proxy 사용 */
const API_HOST = (process.env.REACT_APP_API_HOST || '').replace(/\/$/, '');

export const AUTH_BASE = `${API_HOST}/api/auth`;
export const USERS_API_BASE = `${API_HOST}/api/users`;
export const POSTS_API_BASE = `${API_HOST}/api/posts`;
export const CONSTRUCTION_API_BASE = `${API_HOST}/api/constructions`;
